/** Maps Lepton-X internal keys to ABP keys in the default resource (TrainingTracking). */
export const leptonXTranslateOverrides = {
  'language.settings.title': '::Language',
  'theme.settings.title': '::Appearance',
  'theme.settings.darkMode': '::Dark',
  'theme.settings.lightMode': '::Light',
  'theme.settings.semiDarkMode': '::SemiDark',
  'theme.settings.system': '::System',
  'sideMenuLayout.settings.generalSettings': '::GeneralSettings',
  'sideMenuLayout.filterMenu': '::FilterMenu',
  'settings.title': '::ContainerWidth',
  'settings.boxedContainer': '::ContainerWidth:Boxed',
  'settings.fullWidthContainer': '::ContainerWidth:FullWidth',
  'settings.fluidContainer': '::ContainerWidth:Fluid',
  'topMenuLayout.settings.generalSettings': '::GeneralSettings',
  'mobileMenu.settings.title': '::Settings',
  'mobileMenu.menu.title': '::Menu',
  'toolbar.contextMenu.Welcome': '::Welcome',
};
